import { mdmBaseUrl, otpBaseUrl } from './baseUrl.js';
/**
 * 公用请求
*/
import request from '@/utils/http';
// 根据code从数据字典获取
export const getDictionaryDetailByCode = (params) => {
    return request({
        url: `/api-mdm/dictionaryDetail/dict`,
        method: 'get',
        params
    });
};

/**
 *
 * @param { 系统控制参数接口参数 } params
 */
export const controlParams = (params) => {
    return request({
        url: `${mdmBaseUrl}/controlParams`,
        method: 'get',
        params
    });
};

/**
 *
 * @param { 字典编码 } dictCode
 */
export const getDictDetail = (params) => {
    return request({
        url: `/api-ds/mdmDataDictionaryDetails/page`,
        method: 'get',
        params
    });
};

/**
 * @description 获取OSS临时访问地址
 * @param { OSS私有url } url
 */
export const getOssTempUrl = (url) => {
    return request({
        url: `${otpBaseUrl}/lc/downloadUrl2`,
        method: 'post',
        data: {
            fileUrl: url
        }
    });
};

// 提交mip流程
export const createProcess = (data) => {
    return request({
        url: `/api-iflow/approveProcess?tenantCode=${data.tenantCode}&appCode=${data.currentApplicationCode}`,
        method: 'post',
        data
    }).then(res => res);
};

/**
 * @description 保存到日志
 * @param uniqueKey 订单号(IN单号)、task单号(TASK单号)、外部客户单号(IN单号)、VIP客户配置(VIP_CUSTOMER_ID)、订购面单
 * @param customerOrderNo 可填，有就传，没有就不传
 * @param operateFlag Y/N
 * @param userInfo 结果(成功Y 1/失败 N 0)
 * @param createUserCode 美信账户名
 */
export const saveInformationSecurityLog = (params) => {
    return request({
        url: `${otpBaseUrl}/informationSecurityLog`,
        method: 'get',
        params
    });
};

/** 获取鉴权 */
export const getItsmLogin = (data) => {
    return request({
        url: `${otpBaseUrl}/itsmLogin`,
        method: 'post',
        data
    }).then(res => res);
};
